export function Step({
  n,
  title,
  body,
}: {
  n: number
  title: string
  body: string
}) {
  return (
    <li className="relative">
      <span className="absolute -left-12 flex size-8 items-center justify-center rounded-full border border-primary/30 bg-primary-soft text-sm font-semibold text-primary">
        {n}
      </span>
      <h3 className="font-semibold tracking-tight">{title}</h3>
      <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
        {body}
      </p>
    </li>
  )
}
